// extracted by mini-css-extract-plugin
export default {"createToken":"KlZLaNak9U1VJl5HoZVA"};